export const buildProductUrl = (dgiStyle, color) => {
  const encodedColor = color ? encodeURIComponent(color) : undefined;
  // going to have to revisit this over time
  // once we find out what else we need to navigate on
  const paramsAppendage = encodedColor ? `?color=${encodedColor}` : '';
  return `/product/${dgiStyle}${paramsAppendage}`;
};
